const singleSeekerGender = document.querySelectorAll(
  '.form_radio_single-seeker',
);
const multipleSeekersGender = document.querySelectorAll(
  '.form_radio_multi-seeker',
);
const lookingForRow = document.querySelector('.form_row_looking_for');
const roomSizes = document.querySelectorAll('.form_row_looking_for input');
const roomReqHidden = document.getElementById('roomReqHidden');
const stepOneForm = document.getElementsByName('place_room_wanted_st_1')[0];

const showMultiSeekerOptions = () => {
  multipleSeekersGender.forEach((radioButton) => {
    radioButton.style.display = 'inline-flex';
    radioButton.querySelector('input').removeAttribute('disabled');
  });
  singleSeekerGender.forEach((radioButton) => {
    radioButton.style.display = 'none';
    radioButton.querySelector('input').setAttribute('disabled', '');
  });
};

const showSingleSeekerOptions = () => {
  singleSeekerGender.forEach((radioButton) => {
    radioButton.style.display = 'inline-flex';
    radioButton.querySelector('input').removeAttribute('disabled');
  });
  multipleSeekersGender.forEach((radioButton) => {
    radioButton.style.display = 'none';
    radioButton.querySelector('input').setAttribute('disabled', '');
  });
};

// Set up for gender and room fields on edit ad page
const updateGenderOptions = () => {
  const selectedSeeker = document.querySelector(
    'input[name="who_is_searching"]:checked',
  );

  if (!selectedSeeker || selectedSeeker.value === 'justme') {
    return;
  }

  showMultiSeekerOptions();
  setupRoomSizes(selectedSeeker.value);
};

// Set RoomReq field based on who is looking
const setupRoomSizes = (value) => {
  if (value !== 'justme') {
    lookingForRow.style.display = 'none';
    roomSizes.forEach((input) => input.setAttribute('disabled', ''));
    roomReqHidden.removeAttribute('disabled');
  }

  if (value === 'friend') {
    roomReqHidden.value = '2 rooms';
  }

  if (value === 'partner') {
    roomReqHidden.value = 'a double room';
  }
};

const resetRoomsAndSeekers = () => {
  lookingForRow.removeAttribute('style');
  roomSizes.forEach((input) => input.removeAttribute('disabled'));
  roomReqHidden.setAttribute('disabled', true);
};

const handleChangeEvent = (event) => {
  const { value } = event.target;
  const couplesInput = document.getElementsByName('couples')[0];

  resetRoomsAndSeekers();
  setupRoomSizes(value);

  // Needed on edit ad step
  if (couplesInput) {
    couplesInput.value = value === 'partner' ? 'Y' : 'N';
  }

  if (value === 'justme') {
    showSingleSeekerOptions();
  }

  if (value === 'friend' || value === 'partner') {
    showMultiSeekerOptions();
  }
};

// Step 2 reload form if number of seekers changes
const handleNumberOfSeekersChange = (event) => {
  const initialNumAndGender = document.getElementsByName(
    'prev_NumberAndSexOfSeekers',
  )[0];
  const { value } = event.target;

  if (value.length !== initialNumAndGender.value.length) {
    document
      .createElement('form')
      .submit.call(document.getElementById('wantedAdFormStepTwo'));
  }
};

/** Store selected gender for Chrome back button */
/** Chrome not retaining gender value fix */
const storeSelectedValues = () => {
  stepOneForm.addEventListener('submit', () => {
    const selectedSeeker = document.querySelector(
      'input[name="who_is_searching"]:checked:not([disabled])',
    );
    const selectedGender = document.querySelector(
      'input[name="NumberAndSexOfSeekers"]:checked:not([disabled])',
    );
    if (selectedSeeker) {
      sessionStorage.setItem('who_is_looking', selectedSeeker.value);
    }
    if (selectedGender) {
      sessionStorage.setItem('gender', selectedGender.value);
    }
  });
};

const setStepOneHistoryValues = () => {
  const gender = sessionStorage.getItem('gender');
  const whoIsLooking = sessionStorage.getItem('who_is_looking');
  const performanceTypes = performance.getEntriesByType('navigation')[0];

  sessionStorage.removeItem('gender');
  sessionStorage.removeItem('who_is_looking');

  if (
    gender &&
    whoIsLooking &&
    performanceTypes &&
    performanceTypes.type === 'back_forward'
  ) {
    document.querySelector(
      `input[name="NumberAndSexOfSeekers"][value="${gender}"]`,
    ).checked = true;

    if (gender.length > 1) {
      showMultiSeekerOptions();
      setupRoomSizes(whoIsLooking);
    }
  }
};

export {
  handleChangeEvent,
  updateGenderOptions,
  storeSelectedValues,
  setStepOneHistoryValues,
  handleNumberOfSeekersChange,
};
